import React from "react";
import { Grid, Typography, TextField } from "@mui/material";

export default function CostField({
  costMinValue,
  costMaxValue,
  classes,
  onChange,
}) {
  const handleChangeMin = (e) => {
    const val = e.target.value;
    if (val !== "" && !/^[0-9\b]+$/.test(val)) return;
    const newData = { cost_min: val };
    if (val === "") {
      newData.cost_not_set = false;
    }
    onChange(newData);
  };

  const handleChangeMax = (e) => {
    const val = e.target.value;
    if (val !== "" && !/^[0-9\b]+$/.test(val)) return;
    const newData = { cost_max: val };
    if (val === "") {
      newData.cost_not_set = false;
    }
    onChange(newData);
  };

  return (
    <>
      <Grid
        item
        xs={4}
        sm={2.5}
        sx={{
          fontWeight: "bold",
          paddingLeft: { xs: "10px", sm: "30px" },
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        単価(万円)
      </Grid>
      <Grid
        item
        xs={3.5}
        sm={2}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        <TextField
          className={classes?.inputArea}
          variant="standard"
          fullWidth
          name="costMin"
          id="costMin"
          InputProps={{
            style: { fontSize: 16 },
          }}
          value={costMinValue || ""}
          onChange={handleChangeMin}
        />
      </Grid>
      <Grid
        item
        xs={1}
        sm={1.5}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        <Typography align="center">〜</Typography>
      </Grid>
      <Grid
        item
        xs={3.5}
        sm={2}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        <TextField
          className={classes?.inputArea}
          variant="standard"
          fullWidth
          name="costMax"
          id="costMax"
          InputProps={{
            style: { fontSize: 16 },
          }}
          value={costMaxValue || ""}
          onChange={handleChangeMax}
        />
      </Grid>
    </>
  );
}